import type { InteractiveCapability, MiniSnapshot, MiniSession } from '@ndrc/app-sdk/client';
import { callCore, mutateCore } from '../lib/rpc';
export function createInteractiveCapability(
  classId: string | undefined,
  readOnly: boolean,
): InteractiveCapability {
  return {
    list: () =>
      callCore<{ sessions: MiniSession[] }>('interactive.mine', classId ? { classId } : {}),
    open: (activityId) => callCore<MiniSnapshot>('interactive.state', { activityId }),
    respond: async (activityId, revision, requestId, action, exerciseId, answer) => {
      if (readOnly) throw new Error('Cette consultation est en lecture seule.');
      return mutateCore<MiniSnapshot>(
        'interactive.respond',
        { activityId, revision, requestId, action, exerciseId, answer },
        requestId,
      );
    },
  };
}
